import get from 'lodash/get';
import { array, bool, func, oneOf } from 'prop-types';
import React, { PureComponent } from 'react';

import Button from 'shared/components/button/Button';
import ComponentLoadingSection from 'shared/components/ComponentLoadingSection';
import { formatDateTimeShort } from 'shared/utils/dateUtils';
import { getProductDisplayName } from 'shared/utils/productUtils';

export default class calendarList extends PureComponent {
  static propTypes = {
    calendar: array.isRequired,
    loading: bool.isRequired,
    onItemClick: func.isRequired,
    variant: oneOf(['ATG', 'sports']).isRequired,
  };

  render() {
    const { calendar, onItemClick, loading, variant } = this.props;

    return (
      <ComponentLoadingSection loading={loading}>
        <ul>
          {calendar.map(day => {
            const formattedDay = formatDateTimeShort(
              variant === 'ATG' ? day.firstRacePostTime : day[0].closeTime,
            );
            const nameLabel =
              variant === 'ATG'
                ? get(day, 'track.domesticText')
                : 'Svenska Spel Sport & Casino';
            return (
              <li
                key={`${formattedDay}_${nameLabel}`}
                className="calendar-item"
              >
                <div className="calendar-item__game">
                  <strong className="calendar-item__game_name">
                    {nameLabel}
                  </strong>{' '}
                  {formattedDay}
                </div>
                <ul>
                  {variant === 'ATG'
                    ? day.betParamsList.map(betParams => (
                        <li key={betParams.betType}>
                          <Button
                            className="calendar-item__bet-button"
                            onClick={() => onItemClick(betParams)}
                          >
                            {betParams.betType === 'T'
                              ? 'Trio'
                              : betParams.betType}
                          </Button>
                        </li>
                      ))
                    : day.map(event => (
                        <li key={event.id}>
                          <Button
                            className="calendar-item__bet-button"
                            onClick={() => onItemClick(event.betParams)}
                          >
                            {getProductDisplayName(event.betParams.product)}
                          </Button>
                        </li>
                      ))}
                </ul>
              </li>
            );
          })}
        </ul>
      </ComponentLoadingSection>
    );
  }
}
